<template>
    <v-form @submit.prevent="addEditBankDetails" ref="form">
        <v-card dense class="rounded-4">
            <v-toolbar flat height="45px">
                <span class="font-weight-bold ">{{mode}} Bank Details</span>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="closeDialog()">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            
            <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                Error encountered. Please contact support@sweldonow.ph. Error details: {{ errorMessage }}
            </v-alert> 

            <v-card-text>
                <v-layout row wrap class="mr-20 ml-20">  
                    <v-flex xs12> 
                        <v-autocomplete
                            v-model="bankId"
                            :disabled="disabled"
                            :items="banks"
                            :loading="loading"
                            :rules="[rules.required]"
                            chips
                            color="primary lighten-2"
                            label="Select Bank"
                            item-text="bankName"
                            item-value="bankId"
                            persistent-hint
                            >
                            <template v-slot:selection="data">
                                <v-chip :selected="data.selected" class="chip--select-multi ml-0">
                                    {{ data.item.bankName }}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                </template>
                                <template v-else>
                                    <v-list-tile-content>
                                        <v-list-tile-title v-html="data.item.bankName"></v-list-tile-title>
                                        <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </template>
                            </template>
                        </v-autocomplete> 
                    </v-flex>
                </v-layout>
                <v-layout row wrap class="mr-20 ml-20">  
                    <v-flex xs12> 
                        <v-textarea v-model="bankBranch" :rules="[rules.required]" label="Bank Branch" rows="1" color="primary"></v-textarea>
                    </v-flex>
                </v-layout>
                <v-layout row wrap class="mr-20 ml-20">  
                    <v-flex xs12> 
                        <v-text-field label="Bank Account" 
                            v-model="bankAccount" 
                            :disabled="disabled"
                            :rules="[rules.required]"
                            type="number"
                            ></v-text-field>  
                    </v-flex>
                </v-layout>
            </v-card-text>  
            <v-divider></v-divider>
            <v-card-actions class="mr-25">
                <v-spacer></v-spacer>
                <v-btn v-if="mode!='Update'" @click="clearForm" :disabled="disabled">Clear</v-btn>
                <v-btn color="primary" type="submit" :loading="loading">Save</v-btn>
            </v-card-actions>
        </v-card>
  </v-form>
</template>
<script>

import banksApi from '@/api/banks'

export default {
    name: 'dialog',
    data () {
        return {
            mode: null,
            loading: false,
            disabled: false,   
            rules: {
                required: value => !!value || 'Required.'
            },
            error: false,
            errorMessage: '',
            banks: [],
            userId: null,
            bankId: null,
            bankBranch: null,
            bankAccount: null,
            mode: null
        }
    },
    methods: {
        async setParams(data) {
            if (!this.banks.length) 
                await this.getBanks()

            this.userId = data.userId
            this.mode = 'Add'

            if (data.bankDetails) {
                this.mode = 'Update'
                this.bankId = data.bankDetails.bankId
                this.bankBranch = data.bankDetails.bankBranch
                this.bankAccount = data.bankDetails.bankAccount
            }
        },
        async getBanks() {
            try {
                this.loading = true

                const response = await banksApi.getAll()
                if (response.status==200) {
                    this.banks = response.data.items
                }

                this.loading = false
            }catch(error) {
                this.errorMessage = error
                this.error = true
            }
        },
        async addEditBankDetails() {
            if (this.$refs.form.validate()) {
                try{
                    this.loading = true
                    this.disabled = true
                    
                    var response = null
                    var data = {
                        userId: this.userId,
                        bankId: this.bankId,
                        bankBranch: this.bankBranch,
                        bankAccount: this.bankAccount
                    }
                    if (this.mode == 'Add')
                        response = await banksApi.add(data)
                    else
                        response = await banksApi.update(data)
                    
                    if (response.status==200) {
                        this.closeDialog()
                        this.$emit('send', '')
                    }

                    this.loading = false
                    this.disabled = false
                }catch(error) {
                    this.errorMessage = error
                    this.error = true
                }
            }
        },
        closeDialog() {
            this.$emit('update:dialogUpdateBank', false)
            this.clearForm()
        },
        clearForm() {
            this.$refs.form.reset()
            this.loading = false
            this.error = false
        }
    },
}
</script>